module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "p21",
      "title": "21"
    }
  }, [_c('p', {
    staticClass: "icon"
  }, [_c('span', {
    staticClass: "grey"
  }, [_vm._v("[")]), _vm._v(" QUICK PREP "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("]")])]), _vm._v(" "), _c('h2', {
    staticClass: "recipetitle",
    attrs: {
      "id": "upside_down_banana_walnut_french_toast"
    }
  }, [_vm._v("Upside-Down Banana-Walnut French Toast")]), _vm._v(" "), _c('p', {
    staticClass: "recipetime"
  }, [_c('span', {
    staticClass: "yield_black"
  }, [_vm._v("10 servings")]), _vm._v(" "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Prep Time: 15 Minutes "), _c('span', {
    staticClass: "separater"
  }, [_vm._v("|")]), _vm._v(" Start to Finish: 2 Hours 10 Minutes")]), _vm._v(" "), _c('p', {
    staticClass: "dot"
  }, [_vm._v("•••")]), _vm._v(" "), _c('ul', {
    staticClass: "ingredient"
  }, [_c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1½")]), _vm._v(" cups packed brown sugar")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" cup butter, melted")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("¼")]), _vm._v(" cup light corn syrup")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("½")]), _vm._v(" cup chopped walnuts")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("3")]), _vm._v(" medium bananas, sliced")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" loaf (about 1 lb) sliced unfrosted firm cinnamon bread")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("6")]), _vm._v(" eggs")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1½")]), _vm._v(" cups milk")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }, [_vm._v("1")]), _vm._v(" teaspoon vanilla")]), _vm._v(" "), _c('li', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "qty1"
  }), _vm._v(" Powdered sugar, if desired")])]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("1")]), _vm._v(" Spray 13x9-inch (3-quart) glass baking dish with cooking spray. In large bowl, stir brown sugar, butter, corn syrup and walnuts until smooth. Gently stir in bananas. Spoon mixture into baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("2")]), _vm._v(" Reserve ends of bread loaf for another use; they do not soak up egg mixture very well. Arrange 2 layers of bread on banana mixture, tearing bread to fit if needed.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("3")]), _vm._v(" In medium bowl, beat eggs, milk and vanilla with whisk until well blended. Pour over bread.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("4")]), _vm._v(" Cover; refrigerate at least 1 hour but no longer than 24 hours. Or to freeze, wrap dish tightly. Freeze up to 3 months. Thaw 12 to 24 hours in refrigerator until completely thawed.")]), _vm._v(" "), _c('p', {
    staticClass: "recipeprocedure"
  }, [_c('span', {
    staticClass: "stepnum"
  }, [_vm._v("5")]), _vm._v(" Heat oven to 325°F. Uncover or unwrap baking dish. Bake 45 to 55 minutes or until knife inserted in center comes out clean. Serve portions upside down, spooning sauce from bottom of dish over each serving. Sprinkle with powdered sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_info"
  }, [_c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("1 Serving:")]), _vm._v(" Calories 490; Total Fat 19g (Saturated Fat 7g, Trans Fat 1g); Cholesterol 155mg; Sodium 380mg; Total Carbohydrate 72g (Dietary Fiber 2g); Protein 10g "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Exchanges:")]), _vm._v(" 3 Starch, 2 Other Carbohydrate, 3½ Fat "), _c('span', {
    staticClass: "nutr_bold"
  }, [_vm._v("Carbohydrate Choices:")]), _vm._v(" 5")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_note"
  }, [_c('span', {
    staticClass: "tips"
  }, [_vm._v("In a Flash")]), _vm._v(" This brunch recipe does double duty—you can either freeze it and serve whenever you like, or prepare it the night before for a stress-free brunch.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d2d1c3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/p021.vue
// module id = 111
// module chunks = 0